import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
	routes: [
		{
			path: '/',
			// name: 'layout',
			component: () => import('@/layout/Layout.vue'),
			children: [
				{
					path: '/',
					name: 'index',
					component: () => import('@/views/Index.vue'),
				},
				{
					path: '/department',
					name: 'Department',
					component: () => import('@/views/department/List.vue'),
				},
				{
					path: '/users',
					name: 'Users',
					component: () => import('@/views/users/List.vue'),
				},
				{
					path: '/groups',
					name: 'Groups',
					component: () => import('@/views/groups/List.vue'),
				},
				{
					path: '/menus',
					name: 'Menus',
					component: () => import('@/views/menus/List.vue'),
				},
				{
					path: '/actions',
					name: 'Actions',
					component: () => import('@/views/actions/List.vue'),
				},
				{
					path: '/flowtype',
					name: 'Flowtype',
					component: () => import('@/views/approve/Flowtypelist.vue'),
				},
				{
					path: '/flowform',
					name: 'Flowform',
					component: () => import('@/views/approve/Flowformlist.vue'),
				},
				{
					path: '/flowset',
					name: 'Flowset',
					component: () => import('@/views/approve/Flowsetlist.vue'),
				},
				{//没有用到
					path: '/flowstep',
					name: 'Flowstep',
					component: () => import('@/views/approve/Flowsteplist.vue'),
				},
				{
					path: '/platform',
					name: 'Platform',
					component: () => import('@/views/platform/List.vue'),
				},
				{
					path: '/supplier',
					name: 'Supplier',
					component: () => import('@/views/supplier/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/customer',
					name: 'Customer',
					component: () => import('@/views/customer/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/project',
					name: 'Project',
					component: () => import('@/views/project/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/execute',
					name: 'Execute',
					component: () => import('@/views/execute/List.vue'),
				},
				{
					path: '/contract',
					name: 'Contract',
					component: () => import('@/views/contract/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/invoiceentry',
					name: 'Invoiceentry',
					component: () => import('@/views/invoiceentry/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/applyinvoice',
					name: 'Applyinvoice',
					component: () => import('@/views/applyinvoice/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/openinvicelist',
					name: 'Openinvicelist',
					component: () => import('@/views/applyinvoice/Openinvicelist.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/hclist',
					name: 'Hclist',
					component: () => import('@/views/applyinvoice/Hclist.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/bankline',
					name: 'Bankline',
					component: () => import('@/views/bankline/List.vue'),
				},
				{
					path: '/resource',
					name: 'Resource',
					component: () => import('@/views/resource/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/checklist',
					name: 'Checklist',
					component: () => import('@/views/approve/Checklist.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/applyCollection',
					name: 'ApplyCollection',
					component: () => import('@/views/applyCollection/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/bankcard',
					name: 'Bankcard',
					component: () => import('@/views/other/Bankcardlist.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/invoice',
					name: 'Invoice',
					component: () => import('@/views/other/Invoicelist.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/news',
					name: 'News',
					component: () => import('@/views/other/Newslist.vue'),
					meta: { keepAlive: true }
				},
				//异步任务列表
				{
					path: '/taskslist',
					name: 'TasksList',
					component: () => import('@/views/other/Taskslist.vue'),
				},
				{
					path: '/paycollection',
					name: 'PayCollection',
					component: () => import('@/views/payCollection/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/solve',
					name: 'Solve',
					component: () => import('@/views/solve/List.vue'),
					meta: { keepAlive: true }
				},
				{
					path: '/refund',
					name: 'Refund',
					component: () => import('@/views/refund/List.vue'),
					meta: { keepAlive: true }
				},

			]
		},
		{
			path: '/login',
			name: 'login',
			component: () => import('@/login/login.vue'),
		},
		{
			path: '/details',
			name: 'Details',
			component: () => import('@/details_layout/Layout.vue'),
			children: [
				{//资源详情
					path: '/resourceDetail',
					name: 'ResourceDetail',
					component: () => import('@/views/resource/Detail.vue'),
				},
				{//项目详情
					path: '/projectDetail',
					name: 'ProjectDetail',
					component: () => import('@/views/project/Detail.vue'),
				},
				{//项目详情-资源匹配
					path: '/resourceCart',
					name: 'ResourceCart',
					component: () => import('@/views/resource/Listcart.vue'),
				},
				{//客户详情
					path: '/customerDetail',
					name: 'CustomerDetail',
					component: () => import('@/views/customer/Detail.vue'),
				},
				{//供应商详情
					path: '/supplierDetail',
					name: 'SupplierDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//申请开票详情
					path: '/openDetail',
					name: 'OpenDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//红冲详情
					path: '/hcDetail',
					name: 'HcDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//申请收票详情
					path: '/invoiceCollectDetail',
					name: 'InvoiceCollectDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//发票录入详情
					path: '/entryDetail',
					name: 'EntryDetail',
					component: () => import('@/views/invoiceentry/Detail.vue'),
				},
				{//申请收款详情
					path: '/collectionDetail',
					name: 'CollectionDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//申请退款详情
					path: '/refundDetail',
					name: 'RefundDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//合同详情
					path: '/contractDetail',
					name: 'ContractDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//银行卡详情
					path: '/bankcardDetail',
					name: 'BankcardDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//发票信息详情
					path: '/invoiceDetail',
					name: 'InvoiceDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//结案反结案详情
					path: '/solveDetail',
					name: 'SolveDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				//消息列表
				{
					path: '/message',
					name: 'Message',
					component: () => import('@/views/message/List.vue'),
				},
				//消息详情
				{
					path: '/messageDetail',
					name: 'MessageDetail',
					component: () => import('@/views/message/Detail.vue'),
				},
				//公告详情
				{
					path: '/newsDetail',
					name: 'NewsDetail',
					component: () => import('@/views/message/DetailNews.vue'),
				},
				//申请付款详情
				{
					path: '/paycollectdetail',
					name: 'payCollectDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				//申请撤销对账详情
				{
					path: '/cancelBillDetail',
					name: 'cancelBillDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				//执行审批详情
				{
					path: '/costDetail',
					name: 'CostDetail',
					component: () => import('@/views/applyinvoice/Detail.vue'),
				},
				{//平台详情
					path: '/platformDetail',
					name: 'PlatformDetail',
					component: () => import('@/views/platform/Detail.vue'),
				},
			]
		},
		{
			path: '/ceshi',
			name: 'ceshi',
			component: () => import('@/views/Ceshi.vue'),
		},
		{
			path: '/*',
			component: () => import('@/views/404.vue'),
		}
	]
})
